import { jsxs as d, jsx as o } from "react/jsx-runtime";
import "react";
/* empty css                */
import { classes as f } from "../../utils/component.es.js";
const E = ({
  as: s = "button",
  variant: e = "secondary",
  size: a = "base",
  disabled: t = !1,
  href: m,
  className: r,
  children: l,
  icon: n,
  isLoading: c,
  loadingText: u,
  onClick: i,
  ...b
}) => {
  const p = f("m-button", `m-button--${e}`, `m-button--${a}`, r);
  return /* @__PURE__ */ d(
    s,
    {
      className: p,
      "aria-disabled": t,
      disabled: t,
      href: s === "a" && !t ? m : void 0,
      ...b,
      onClick: i,
      children: [
        n && /* @__PURE__ */ o("span", { className: "m-button__icon", children: n }),
        l,
        c && /* @__PURE__ */ o("span", { className: "m-button__loading", children: u })
      ]
    }
  );
};
export {
  E as default
};
//# sourceMappingURL=MButton.es.js.map
